import React from 'react';
import { useTranslation } from 'react-i18next';
import { COVERING_TABLE_INTERNAL_HOURS_FTE_OPT } from '../../../i18n/keyConstants';

const FTECheckbox = ({ value, onChange }) => {
    const { t } = useTranslation(['coveringTable']);
    return (
        <div className='btn btn-light p-2 w-100 h-100' onMouseDown={onChange}>
            <label id='fte-checkbox' className='checkbox-item d-flex p-auto w-100 mb-0'>
                <div className='pr-3'>
                    <input type='checkbox' checked={value} readOnly={true} />
                    <span className='flexible-checkmark my-auto' />
                </div>
                <div className='d-flex pl-4 my-auto'>
                    <div className='d-none d-lg-block'>{t(COVERING_TABLE_INTERNAL_HOURS_FTE_OPT)}</div>
                </div>
            </label>
        </div>
    );
};

export default FTECheckbox;
